@if (offline()) {
  <div class="offline-banner" role="status" aria-live="polite" data-testid="offline-banner">
    <span class="offline-banner__dot" aria-hidden="true"></span>
    <span class="offline-banner__text">
      You're offline. We'll keep retrying — recent pages are still available from cache.
    </span>
  </div>
}
